// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"d9d88b5e","51":"84ce677a","96":"fc715123","199":"a1753d13","312":"bf9554fa","354":"812bcc48","371":"735be718","387":"7811fc43","450":"a382ec35","453":"68f49fa0","526":"99d02b13","670":"fc92448a","674":"e01e7284","699":"d262da90","843":"664c4d31"}[chunkId] + ".chunk.js";
};